import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button, ConfirmationModal } from "@touchtech/web-baselayer-ui";

import { TranslationContext } from "@is/constants";

import css from "./RemoveCollectionModal.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
};

const RemoveCollectionModal = ({
  isOpen,
  onClose,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
}: Props) => {
  const { t } = useTranslation(TranslationContext.Settings);

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      buttonsRight={[
        <Button
          key="secondary"
          onClick={onSecondaryButtonClick}
          className={css.button}
          sizing="lg"
        >
          {t("Cancel")}
        </Button>,
        <Button
          key="primary"
          onClick={onPrimaryButtonClick}
          className={classcat([css.button, css.primaryButton])}
          sizing="lg"
        >
          {t("Continue")}
        </Button>,
      ]}
    >
      <div className={css.container}>
        <h1 className={classcat([css.title, "text-headline-5xl"])}>
          {t("Remove this collection?")}
        </h1>
        <span className={css.subtitle}>
          {t("The collection and items will be permanently removed.")}
        </span>
      </div>
    </ConfirmationModal>
  );
};

export default RemoveCollectionModal;
